module.exports = __webpack_public_path__ + "img/pr-9.f49ca21b.png";